import { forwardRef, type SelectHTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  invalid?: boolean;
}

export const Select = forwardRef<HTMLSelectElement, SelectProps>(function Select(
  { invalid, className, children, ...rest },
  ref,
) {
  return (
    <select
      ref={ref}
      aria-invalid={invalid || undefined}
      className={cn(
        'h-10 w-full rounded border bg-white px-3 pr-8 text-sm text-brand-charcoal',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-blue focus-visible:ring-offset-1',
        'disabled:cursor-not-allowed disabled:bg-brand-gray-light disabled:opacity-60',
        invalid
          ? 'border-brand-danger focus-visible:ring-brand-danger'
          : 'border-brand-gray-light hover:border-brand-gray-mid',
        className,
      )}
      {...rest}
    >
      {children}
    </select>
  );
});
